// extracted by mini-css-extract-plugin
export default {"wrapper":"Place_wrapper__NOBKB","list":"Place_list__BsNj4"};